import { LOCALISE_LANGUAGE_FIELD_NAME, PARENT_FIELD } from '@pkg/config/sanity/constants';
import { slugWithParents } from '@pkg/sanity-utils/slugWithParents';
import { modularContentBlocks } from '@pkg/modular-blocks/frontend/web-app';

/**
 * The shallow query. Most useful as a Listen query for Draft Mode.
 * When using this query, you must pass parameters `{ locale: "en-gb" }` or other LOCALE_CODE, or it will not work
 * e.g. return useSanityData<Type, Err>(someQuery, { locale: unrefLocale });
 *
 * `_translations` (hreflang) leaves out hidden pages. The parentheses make the filter apply to
 * the dereferenced list, not to each element.
 */
export const shallowPageFields = groq`
  _id,
  _type,
  title,
  browserLocaleRedirect,
  ${PARENT_FIELD},
  ${LOCALISE_LANGUAGE_FIELD_NAME},
  pageVisibility,
  seoSocial,
  hideHeader,
  "_translations": (*[_type == "translation.metadata" && references(^._id)].translations[].value->)[pageVisibility != "hidden"]{
    title,
    ${slugWithParents},
    language
  }
`;

/**
 * When using this query, you must pass parameters `{ locale: "en-gb" }` or other LOCALE_CODE, or it will not work
 * e.g. return useSanityData<Type, Err>(someQuery, { locale: unrefLocale });
 */
export const pageFields = groq`
  ${shallowPageFields},
  content[] {
    ${modularContentBlocks}
  },
  ${slugWithParents},
`;
